var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var RadioCheckedIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M18.2222222,4 L5.77777778,4 C4.79111111,4 4,4.8 4,5.77777778 L4,18.2222222 C4,19.2 4.79111111,20 5.77777778,20 L18.2222222,20 C19.2088889,20 20,19.2 20,18.2222222 L20,5.77777778 C20,4.8 19.2088889,4 18.2222222,4 Z M10.495465,15.3335923 L8.01333333,12.8514606 C7.66723489,12.5053622 7.66723489,11.9442257 8.01333333,11.5981273 C8.35960775,11.2518529 8.92087897,11.2513653 9.26775448,11.5970376 L10.8490194,13.1728176 C11.0443803,13.3675007 11.3604891,13.3672261 11.5555114,13.1722038 L16.0632669,8.66444837 C16.4093697,8.3183456 16.9705131,8.3183456 17.3166159,8.66444837 C17.317354,8.6651865 17.3180908,8.66592593 17.3188264,8.66666667 C17.6652824,9.01557986 17.664287,9.57898379 17.3166002,9.92667059 L11.9096785,15.3335923 C11.5191542,15.7241166 10.8859893,15.7241166 10.495465,15.3335923 Z" }))); };
export default RadioCheckedIcon;
